import GeoJSON from 'ol/format/GeoJSON';
import {Vector as VectorSource} from 'ol/source';
import {Vector as VectorLayer} from 'ol/layer';
import Feature from 'ol/Feature';
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style';


export const lineDrawLayer = new VectorLayer({
    source: new VectorSource(),
    name:'Çizimler',
    desc:'katman',
    tip:'vector',
    opacity:0.9,
    zIndex:50,
    style: new Style({
      fill: new Fill({
        color: 'rgb(0, 102, 153)',
        opacity:'0.3'
      }),
      stroke: new Stroke({
        color: '#89d1d6',
        width: 2,
      }),
      image: new CircleStyle({
        radius: 7,
        fill: new Fill({
          color: '#89d1d6',
        }),
      }),
    }),
  });